import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { onAnswer, onIce, onOffer, sendAnswer, sendIce } from '../services/realtimeService';

const stunServers: RTCIceServer[] = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' }
];

const ScreenShareViewerPage: React.FC = () => {
  const [params] = useSearchParams();
  const targetUserId = params.get('targetUserId') || '';
  const [videoRef] = React.useState(() => React.createRef<HTMLVideoElement>());
  const pcRef = React.useRef<RTCPeerConnection | null>(null);

  React.useEffect(() => {
    const pc = new RTCPeerConnection({ iceServers: stunServers });
    pcRef.current = pc;

    pc.onicecandidate = (e) => {
      if (e.candidate) {
        sendIce(targetUserId, e.candidate);
      }
    };
    pc.ontrack = (e) => {
      const [stream] = e.streams;
      if (videoRef.current) videoRef.current.srcObject = stream;
    };

    const subOffer = onOffer((fromUserId, sdp) => {
      if (fromUserId !== targetUserId) return;
      pc.setRemoteDescription(new RTCSessionDescription(sdp)).then(async () => {
        const answer = await pc.createAnswer();
        await pc.setLocalDescription(answer);
        sendAnswer(targetUserId, answer);
      });
    });

    const subIce = onIce((fromUserId, candidate) => {
      if (fromUserId !== targetUserId) return;
      pc.addIceCandidate(new RTCIceCandidate(candidate));
    });

    return () => {
      pc.close();
      pcRef.current = null;
      try { (window as any).socket?.off?.('screenshare:offer'); } catch {}
      try { (window as any).socket?.off?.('screenshare:ice'); } catch {}
    };
  }, [targetUserId]);

  React.useEffect(() => {
    // Otwórz okno fullscreen (należy wywołać z akcji użytkownika – inicjalizacja tutaj w viewerze wystarczy)
    const v = videoRef.current;
    if (!v) return;
    const onCanPlay = async () => {
      try { await v.play(); } catch {}
      try { await v.requestFullscreen?.(); } catch {}
    };
    v.addEventListener('canplay', onCanPlay);
    return () => v.removeEventListener('canplay', onCanPlay);
  }, [videoRef]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#000' }}>
      <video ref={videoRef} autoPlay playsInline muted controls style={{ width: '100%', height: '100%', objectFit: 'contain' }} onLoadedMetadata={async (e) => { try { await (e.currentTarget as HTMLVideoElement).play(); } catch {} }} />
    </div>
  );
};

export default ScreenShareViewerPage;


